import { useEffect } from 'react';
import { tsParticles } from '@tsparticles/engine';
import { loadStarsPreset } from '@tsparticles/preset-stars';

const CONTAINER_ID = 'tsparticles';

export default function NightSky() {
  useEffect(() => {
    let container;

    async function init() {
      await loadStarsPreset(tsParticles);
      container = await tsParticles.load({
        id: CONTAINER_ID,
        options: {
          preset: 'stars',
          background: { color: { value: 'transparent' } },
        },
      });
    }

    init();

    return () => {
      container?.destroy();
    };
  }, []);

  return <div id={CONTAINER_ID} aria-hidden="true" />;
}
